export const modifiers = [
  { name: 'None', color: '#555' },
  { name: 'Negative', color: '#26a69a' },
  { name: 'Glitch', color: '#ec407a' },
  { name: 'Prismatic', color: '#ffee58', text: '#000' },
  { name: 'Glacial', color: '#5db3ff' },
  { name: 'Rainbow', color: '#ff6ad5' },
  { name: 'Cosmic', color: '#7f6bff' },
];
